/**
 * LenderLayout - Enterprise Lender Portal Layout
 * Uses shared AppLayout for consistency
 */
import { useNavigate, Outlet } from 'react-router';
import { AppLayout } from '../../components/layout';
import { LENDER_NAV } from '../../config/navigation';
import { authService } from '../../services/supabaseService';


// Lender configuration (would come from logged-in user profile)
const LENDER_CONFIG = {
  name: 'First National Bank',
  email: 'lending@firstnational.com',
  company: 'First National Bank',
};

const LenderLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authService.signOut();
    navigate('/lender/login');
  };


  return (
    <AppLayout
      role="lender"
      navItems={LENDER_NAV}
      user={{
        name: LENDER_CONFIG.company,
        email: LENDER_CONFIG.email,
        role: 'lender',
      }}
      onLogout={handleLogout}
    >
      <Outlet />
    </AppLayout>
  );
};

export default LenderLayout;
